import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "@/hooks/use-toast";

const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const toasted = useRef(false);

  useEffect(() => {
    if (!loading && !user && !toasted.current) {
      toasted.current = true;
      toast({ title: "Sign in to view your reports." });
      navigate("/signin", {
        replace: true,
        state: { returnTo: location.pathname + location.search },
      });
    }
  }, [loading, user, navigate, location]);

  if (loading) return null;
  if (!user) return null;

  return <>{children}</>;
};

export default RequireAuth;
